import FieldModel          from '@models/map/FieldModel';
import Form                from '@widesk-ui/components/form/Form';
import Input               from '@widesk-ui/components/form/Input';
import FieldTypeModel      from '@models/map/FieldTypeModel';
import SelectFieldType     from '@selects/map/SelectFieldType';
import PagedCollection     from '@widesk-core/models/PagedCollection';

export type FieldFormProps =  {
	model: FieldModel;
	onSuccess?: () => void;
	projectUrn: Urn;
	fieldTypeReferences?: Map_FieldTypeReference[];
	disableContinueAfterSubmit?: boolean;
}

export default function FieldForm(props: FieldFormProps)  {
	return (
		<Form
			onSuccess={props.onSuccess}
			onDidMount={async formTools => {
				const { model } = props;

				if (model.id) {
					formTools.setFieldsValue({
						label: model.label,
						fieldTypeUrn: model.getUrn('fieldType'),
						reference: model.reference,
					});
				}
			}}
			fields={{
				label: {
					label: "Titre",
					element: <Input placeholder="Titre" />,
					required: true,
					span: 24,
				},
				fieldTypeUrn: {
					label: FieldTypeModel.localize(),
					element: <SelectFieldType 	
						filters={{
							reference: props.fieldTypeReferences,
						}}
					/>,
					required: true,
					hidden: props.fieldTypeReferences?.length === 1,
				},
				reference: {
					label: "Référence",
					element: <Input placeholder="Référence" />,
				},
			}}
			continueAfterSubmit={!props.model.id && !props.disableContinueAfterSubmit}
			onSubmit={async (values) => {
				const { model } = props;

				let fieldTypeUrn = values.fieldTypeUrn;
				if (props.fieldTypeReferences?.length === 1) {
					const coll = new PagedCollection(FieldTypeModel);
					coll.setRequiredFilter('reference', props.fieldTypeReferences[0]);
					coll.setItemsPerPage(1);
					await coll.list();
					fieldTypeUrn = coll.first()?.urn;
				}

				await model.patch({
					label: values.label, 
					fieldType: fieldTypeUrn, 
					project: props.projectUrn, 
					reference: values.reference, 
				});

				return model;
			}}
		/>
	);
}